import React, { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Button } from './ui/button';
import { toast } from 'sonner';
import { BACKEND_URL } from '../config/api';

// Embedded base64 paw icon to avoid CORS issues in SVG data URLs
const PAW_ICON_BASE64 = 'data:image/png;base64,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';
// Pin type color configuration (MUST match MapPage.js exactly!)
const PIN_TYPE_CONFIG = {
  standard: { color: '#10B981', emoji: '🐾' },        // emerald-500 - User locations
  cafe: { color: '#8B4513', emoji: '☕' },            // brown - Coffee shops
  bar: { color: '#6B46C1', emoji: '🍷' },             // purple - Bars/pubs
  vet: { color: '#DC2626', emoji: '➕' },             // red - Veterinary clinics
  dog_food: { color: '#F97316', emoji: '🥣' },        // orange - Pet food stores
  grooming: { color: '#EC4899', emoji: '✂' },         // pink - Grooming services
  accessories: { color: '#FBBF24', emoji: '🎾' },     // yellow - Pet accessories
  dog_shelter: { color: '#78716C', emoji: '🏠' },     // gray-brown - Shelters/rescues
  daycare: { color: '#14B8A6', emoji: '☀️' }          // teal - Doggy daycare
};

// Function to get pin color based on category
const getPinColor = (category) => {
  return PIN_TYPE_CONFIG[category]?.color || PIN_TYPE_CONFIG.standard.color;
};

// Function to get pin emoji based on category
const getPinEmoji = (category) => {
  return PIN_TYPE_CONFIG[category]?.emoji || PIN_TYPE_CONFIG.standard.emoji;
};

/**
 * Standalone Map Picker Modal Component
 * Rendered via Portal to avoid conflicts with parent Dialog components
 * Handles Google Maps integration for location selection
 */
const MapPickerModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  initialCoordinates = null,
  initialZoom = null,
  pinCategory = 'standard' // Admin pin type
}) => {
  const [coordinates, setCoordinates] = useState(initialCoordinates);
  const mapPickerRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const markerRef = useRef(null);
  const searchInputRef = useRef(null);
  const autocompleteRef = useRef(null);

  // Initialize map when modal opens
  useEffect(() => {
    if (!isOpen) return;

    // Poll for DOM readiness
    let pollCount = 0;
    const maxPolls = 20;
    
    const pollForContainer = async () => {
      pollCount++;
      console.log(`🔄 MapPicker: Poll attempt ${pollCount}/${maxPolls}`);
      
      if (mapPickerRef.current) {
        console.log('✅ MapPicker: Container ready');
        
        if (window.google?.maps) {
          console.log('✅ MapPicker: Google Maps loaded');
          initializeMap();
        } else {
          console.log('📦 MapPicker: Loading Google Maps...');
          try {
            await loadGoogleMaps();
            initializeMap();
          } catch (error) {
            console.error('❌ MapPicker: Failed to load Google Maps:', error);
            toast.error('Failed to load map. Please try again.');
          }
        }
      } else if (pollCount < maxPolls) {
        setTimeout(pollForContainer, 100);
      } else {
        console.error('❌ MapPicker: Container never appeared');
        toast.error('Map container failed to load.');
      }
    };
    
    setTimeout(pollForContainer, 100);
    
    return () => {
      // Cleanup
      if (autocompleteRef.current) {
        window.google?.maps?.event?.clearInstanceListeners(autocompleteRef.current);
      }
      if (mapInstanceRef.current) {
        window.google?.maps?.event?.clearInstanceListeners(mapInstanceRef.current);
      }
    };
  }, [isOpen]);

  const loadGoogleMaps = () => {
    return new Promise((resolve, reject) => {
      if (window.google?.maps) {
        resolve();
        return;
      }

      const existingScript = document.querySelector('script[src*="maps.googleapis.com"]');
      if (existingScript) {
        existingScript.addEventListener('load', () => resolve());
        existingScript.addEventListener('error', () => reject(new Error('Failed to load Google Maps')));
        return;
      }

      fetch(`${BACKEND_URL}/api/config`)
        .then(res => res.json())
        .then(config => {
          const script = document.createElement('script');
          script.src = `https://maps.googleapis.com/maps/api/js?key=${config.google_maps_api_key}&libraries=places,geometry,marker`;
          script.async = true;
          script.defer = true;
          script.onload = () => resolve();
          script.onerror = () => reject(new Error('Failed to load Google Maps'));
          document.head.appendChild(script);
        })
        .catch(err => reject(err));
    });
  };

  const initializeMap = async () => {
    console.log('🗺️ MapPicker: Initializing map');
    
    await new Promise(resolve => setTimeout(resolve, 500));
    
    if (!mapPickerRef.current) {
      console.error('❌ MapPicker: Container not found');
      return;
    }

    // Intelligent center selection with fallback hierarchy
    const getInitialCenter = () => {
      // 1. Try component state
      if (coordinates) {
        console.log('📍 MapPicker: Using coordinates from state:', coordinates);
        return coordinates;
      }
      
      // 2. Try prop from parent (AddLocationModal)
      if (initialCoordinates) {
        console.log('📍 MapPicker: Using initialCoordinates prop:', initialCoordinates);
        return initialCoordinates;
      }
      
      // 3. Try sessionStorage (last map center from main map)
      const savedCenter = sessionStorage.getItem('lastMapCenter');
      if (savedCenter) {
        try {
          const parsed = JSON.parse(savedCenter);
          if (parsed.lat && parsed.lng) {
            console.log('📍 MapPicker: Using saved map center from sessionStorage:', parsed);
            return parsed;
          }
        } catch (e) {
          console.error('Failed to parse saved map center:', e);
        }
      }
      
      // 4. Final fallback to New York
      console.log('📍 MapPicker: Using default center (New York)');
      return { lat: 40.7589, lng: -73.9851 };
    };

    // Intelligent zoom selection with fallback hierarchy
    const getInitialZoom = () => {
      // 1. Try prop from parent (AddLocationModal)
      if (initialZoom) {
        console.log('🔍 MapPicker: Using initialZoom prop:', initialZoom);
        return initialZoom;
      }
      
      // 2. Try sessionStorage (last map zoom from main map)
      const savedZoom = sessionStorage.getItem('lastMapZoom');
      if (savedZoom) {
        try {
          const parsed = parseInt(savedZoom, 10);
          if (parsed >= 1 && parsed <= 21) {
            console.log('🔍 MapPicker: Using saved map zoom from sessionStorage:', parsed);
            return parsed;
          }
        } catch (e) {
          console.error('Failed to parse saved map zoom:', e);
        }
      }
      
      // 3. Final fallback to 13
      console.log('🔍 MapPicker: Using default zoom (13)');
      return 13;
    };

    const center = getInitialCenter();
    const zoom = getInitialZoom();
    
    try {
      mapPickerRef.current.innerHTML = '';
      
      const mapInstance = new window.google.maps.Map(mapPickerRef.current, {
        mapId: "DEMO_MAP_ID", // Required for AdvancedMarkerElement
        zoom: zoom,
        center: center,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: true,
        zoomControl: true,
        gestureHandling: 'greedy',
        backgroundColor: '#e5e7eb'
      });

      mapInstanceRef.current = mapInstance;

      // Trigger resize events
      setTimeout(() => {
        window.google.maps.event.trigger(mapInstance, 'resize');
        mapInstance.setCenter(center);
      }, 300);

      setTimeout(() => {
        window.google.maps.event.trigger(mapInstance, 'resize');
        mapInstance.setCenter(center);
      }, 800);

      // Map click handler for pin placement
      mapInstance.addListener('click', (e) => {
        const lat = e.latLng.lat();
        const lng = e.latLng.lng();
        
        console.log('📍 MapPicker: Map clicked at:', lat, lng);
        
        // Remove old marker
        if (markerRef.current) {
          markerRef.current.setMap(null);
        }

        // Add new marker using AdvancedMarkerElement with category-specific emoji
        const markerContent = document.createElement('div');
        markerContent.style.cssText = 'position: relative; width: 56px; height: 56px;';
        markerContent.innerHTML = `
          <svg width="56" height="56" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg" style="position: absolute; top: 0; left: 0;">
            <circle cx="28" cy="28" r="26" fill="white" stroke="${getPinColor(pinCategory)}" stroke-width="3"/>
          </svg>
          <div style="position: absolute; top: 10px; left: 10px; width: 36px; height: 36px; display: flex; align-items: center; justify-content: center; font-size: 24px; pointer-events: none;">${getPinEmoji(pinCategory)}</div>
        `;
        
        const marker = new window.google.maps.marker.AdvancedMarkerElement({
          position: { lat, lng },
          map: mapInstance,
          title: 'Selected Location',
          content: markerContent,
        });

        // Note: AdvancedMarkerElement doesn't support setAnimation()
        // Animation is handled via CSS on the marker content element

        markerRef.current = marker;
        setCoordinates({ lat, lng });
        
        // Reverse geocode
        reverseGeocode(lat, lng);
      });

      // Initialize search autocomplete - SCOPED TO INPUT ONLY
      if (searchInputRef.current && window.google?.maps?.places) {
        console.log('🔍 MapPicker: Initializing search autocomplete');
        
        // TODO [Q2-Q3 2025]: Migrate to PlaceAutocompleteElement when Google issues 12-month warning
        // Current API: google.maps.places.Autocomplete (deprecated Mar 2025 for NEW customers only)
        // Migration blocked: PlaceAutocompleteElement breaks React controlled inputs (creates own input)
        // Strategy: Monitor deprecation timeline, migrate when React wrappers mature
        // See: /app/docs/project/FUTURE_TASKS.md - "Google Maps Autocomplete API Migration (Phase 2)"
        const autocomplete = new window.google.maps.places.Autocomplete(
          searchInputRef.current,
          {
            fields: ['formatted_address', 'geometry', 'name', 'address_components']
          }
        );

        autocomplete.bindTo('bounds', mapInstance);

        // Handle place selection
        autocomplete.addListener('place_changed', () => {
          const place = autocomplete.getPlace();

          if (!place.geometry) {
            toast.error('Could not find that location');
            return;
          }

          // Move map
          if (place.geometry.viewport) {
            mapInstance.fitBounds(place.geometry.viewport);
          } else {
            mapInstance.setCenter(place.geometry.location);
            mapInstance.setZoom(15);
          }

          // Place marker
          if (markerRef.current) {
            markerRef.current.setMap(null);
          }

          const markerContent = document.createElement('div');
          markerContent.style.cssText = 'position: relative; width: 56px; height: 56px;';
          markerContent.innerHTML = `
            <svg width="56" height="56" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg" style="position: absolute; top: 0; left: 0;">
              <circle cx="28" cy="28" r="26" fill="white" stroke="${getPinColor(pinCategory)}" stroke-width="3"/>
            </svg>
            <div style="position: absolute; top: 10px; left: 10px; width: 36px; height: 36px; display: flex; align-items: center; justify-content: center; font-size: 24px; pointer-events: none;">${getPinEmoji(pinCategory)}</div>
          `;
          
          const marker = new window.google.maps.marker.AdvancedMarkerElement({
            position: place.geometry.location,
            map: mapInstance,
            title: place.name || place.formatted_address,
            content: markerContent,
          });

          markerRef.current = marker;
          const lat = place.geometry.location.lat();
          const lng = place.geometry.location.lng();
          setCoordinates({ lat, lng });
          
          toast.success(`Found: ${place.name || place.formatted_address}`);
        });

        autocompleteRef.current = autocomplete;
      }

      // Try to get user's location
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const userPos = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };
            mapInstance.setCenter(userPos);
          },
          () => {
            console.log('MapPicker: Could not get user location');
          }
        );
      }

      console.log('✅ MapPicker: Map initialized successfully');
    } catch (error) {
      console.error('❌ MapPicker: Error initializing map:', error);
      toast.error('Failed to load map');
    }
  };

  const reverseGeocode = async (lat, lng) => {
    try {
      if (!window.google?.maps?.Geocoder) return;
      
      const geocoder = new window.google.maps.Geocoder();
      
      geocoder.geocode({ location: { lat, lng } }, (results, status) => {
        if (status === 'OK' && results[0]) {
          console.log('✅ MapPicker: Reverse geocode:', results[0].formatted_address);
          // Success is self-evident: "Confirm Location" button lights up
          // No toast needed - UI state provides feedback
        }
      });
    } catch (error) {
      console.error('❌ MapPicker: Reverse geocode error:', error);
    }
  };

  const handleConfirm = () => {
    if (coordinates) {
      // Include current zoom level in coordinates
      const coordinatesWithZoom = {
        ...coordinates,
        zoom: mapInstanceRef.current ? mapInstanceRef.current.getZoom() : 15
      };
      onConfirm(coordinatesWithZoom);
      setCoordinates(null);
    } else {
      toast.error("Please select a location on the map");
    }
  };

  const handleCancel = () => {
    setCoordinates(null);
    onClose();
  };

  if (!isOpen) return null;

  // Render using Portal to body (outside any Dialog)
  return createPortal(
    <div 
      className="fixed inset-0 flex items-center justify-center"
      style={{ 
        zIndex: 99999,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        backdropFilter: 'blur(4px)'
      }}
      onClick={(e) => {
        // Only close if clicking backdrop directly
        if (e.target === e.currentTarget) {
          handleCancel();
        }
      }}
    >
      <div 
        className="bg-white rounded-lg shadow-2xl w-full max-w-4xl overflow-auto relative"
        style={{ 
          margin: '5px 10px 10px 10px',
          marginTop: '5px',
          maxHeight: 'calc(100vh - 10px)',
          zIndex: 100000
        }}
      >
        {/* Header - Compact for Mobile */}
        <div className="sticky top-0 bg-white border-b px-4 py-3 z-50 flex items-center justify-between">
          <div className="flex-1 min-w-0 pr-3">
            <h2 className="text-base md:text-xl font-semibold truncate">Find Location on Map</h2>
            <p className="text-xs md:text-sm text-gray-600 mt-0.5">Click on the map to place a pin</p>
          </div>
          {/* Orange circle close button with white X */}
          <button
            onClick={handleCancel}
            className="flex-shrink-0 w-10 h-10 rounded-full bg-gradient-to-r from-orange-600 to-red-600 hover:from-orange-700 hover:to-red-700 text-white flex items-center justify-center shadow-lg transition-all"
            aria-label="Close"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Content */}
        <div className="p-4 md:p-6 space-y-3 md:space-y-4">
          {/* Search Bar */}
          <div className="relative">
            <input
              ref={searchInputRef}
              type="text"
              placeholder="Search for a location..."
              className="w-full px-4 py-2 pr-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent text-sm md:text-base"
              autoComplete="off"
            />
            <svg className="absolute right-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </div>

          {/* Map Container - Optimized for mobile with button clearance */}
          <div 
            ref={mapPickerRef}
            className="w-full rounded-lg border-2 border-gray-300"
            style={{ 
              height: 'calc(100vh - 320px)',
              minHeight: '280px',
              maxHeight: '450px',
              cursor: 'pointer'
            }}
          />

          {/* Action Buttons - Extra spacing for toast clearance */}
          <div className="flex gap-3 pt-6 pb-2">
            <Button
              onClick={handleConfirm}
              className={`flex-1 text-sm md:text-base ${coordinates ? 'bg-emerald-600 hover:bg-emerald-700 text-white shadow-lg' : ''}`}
              disabled={!coordinates}
            >
              {coordinates ? '✓ Confirm Location' : 'Select Location First'}
            </Button>
            <Button
              variant="outline"
              onClick={handleCancel}
              className="flex-1 text-sm md:text-base"
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default MapPickerModal;
